import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit,
    OnDestroy,
    Inject,
    signal,
    computed,
} from '@angular/core';
import { showOpacityAnimation } from '../../../animations/show-left-right.animation';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadService } from 'src/app/services/application/load.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import {
    IDataForAuthCode,
    IPatientFind,
    ISendAuthenticationCodeResponse,
    onlyCharsWithHyphenRegex,
} from 'src/app/interfaces/patient.interfaces';
import { dateValidator } from 'src/app/directives/date.validator';
import { interval, lastValueFrom, Subscription } from 'rxjs';
import { TDeliveryChannel } from 'src/app/interfaces/patient.types';
import { ICaptcha, ICaptchaData } from 'src/app/services/captcha/interfaces';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';
import { Utils } from 'src/app/services/utils';
import { DOCUMENT } from '@angular/common';
import { DateTime } from 'luxon';
@Component({
    selector: 'app-auth-recovery',
    templateUrl: './recovery.component.html',
    styleUrls: ['../_auth-shared-styles.scss'],
    animations: [showOpacityAnimation],
    standalone: false,
})
export class RecoveryComponent implements OnInit, AfterViewInit, OnDestroy {
    public page: 'mainData' | 'mailPhone' = 'mainData'; //'codeConfirm';
    public AuthFormTitle: string = '';
    public AccessReg: boolean = false;
    public recoveryTypeParam: string = 'email';
    public patientData: IPatientFind = {
        firstName: '',
        lastName: '',
        secondName: '',
        birthDate: '',
    };
    public loading: boolean = false;
    public captchaLoad: boolean = false;
    public currentStep: number = 50;
    public recoveryMode: TDeliveryChannel = 'EMAIL'; // 'EMAIL', 'SMS';
    public errorMessage: string = '';
    public messageUuid: string = '';
    public captcha: ICaptcha = { id: '', svg: '' };
    private timerSeconds = signal<number>(30);
    public timerDuration: number = 30;
    private isRunning = signal<boolean>(false);
    public isTimerRunning = computed(() => this.isRunning());
    private subscription: Subscription | null = null;
    public maxBdate = DateTime.now().toFormat('yyyy-MM-dd');
    public dateInputType: 'text' | 'date' = 'text';
    @ViewChild('inputField')
    public inputField!: ElementRef<HTMLInputElement>;
    public formRecoveryData: FormGroup = new FormGroup({
        firstName: new FormControl<string>('', [
            Validators.minLength(1),
            Validators.required,
            Validators.pattern(onlyCharsWithHyphenRegex),
        ]),
        lastName: new FormControl<string>('', [
            Validators.minLength(1),
            Validators.required,
            Validators.pattern(onlyCharsWithHyphenRegex),
        ]),
        secondName: new FormControl<string>('', [
            Validators.minLength(1),
            Validators.pattern(onlyCharsWithHyphenRegex),
        ]),
        birthDate: new FormControl('', [Validators.required, dateValidator()]),
    });
    public formMail: FormGroup = new FormGroup({
        email: new FormControl<string>('', [
            Validators.required,
            Validators.email,
        ]),
        captcha: new FormControl<string>('', [
            Validators.required,
            Validators.minLength(6),
        ]),
    });
    public formPhone: FormGroup = new FormGroup({
        phone: new FormControl<string>('', [
            Validators.minLength(11),
            Validators.required,
        ]),
        captcha: new FormControl<string>('', [
            Validators.required,
            Validators.minLength(6),
        ]),
    });
    @ViewChild('InputBlockfirstName') public InputBlockfirstName:
        ElementRef | undefined;
    @ViewChild('InputBlockLastName') public InputBlockLastName:
        ElementRef | undefined;
    @ViewChild('InputBlockSecondName') public InputBlockSecondName:
        ElementRef | undefined;
    @ViewChild('InputBlockBirthDate') public InputBlockBirthDate:
        ElementRef | undefined;
    @ViewChild('InputBlockEmail') public InputBlockEmail:
        ElementRef | undefined;
    public constructor(
        private load: LoadService,
        private auth: AuthService,
        private captchaService: CaptchaService,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.AuthFormTitle =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .AUTH_FORM_TEXT ?? 'Личный кабинет пациента';
        this.AccessReg =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_REGISTRATION_ENABLED;
        this.recoveryTypeParam =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.RECOVERY
                .RECOVERY_PARAMS_LIST ?? 'email';
    }
    public ngOnInit(): void {
        if (
            this.recoveryTypeParam.includes('sms') &&
            !this.recoveryTypeParam.includes('email')
        )
            this.recoveryMode = 'SMS';
        else this.recoveryMode = 'EMAIL';
    }
    public ngAfterViewInit() {
        this.dateInputType = this.birthDateControl.value ? 'date' : 'text';
        this.setFocus();
    }
    public ngOnDestroy(): void {}
    // подтверждение после ввода основной информации о пациенте
    public onSubmitRecoveryData() {
        this.loading = true;

        this.patientData = {
            firstName: this.formRecoveryData.controls['firstName'].value,
            lastName: this.formRecoveryData.controls['lastName'].value,
            secondName:
                this.formRecoveryData.controls['secondName'].value || undefined,
            birthDate: this.formRecoveryData.controls['birthDate'].value,
        };
        this.loading = false;
        this.page = 'mailPhone';
        this.getCaptcha(); // дергаем свежу капчу только перед переходом на стр с капчей
        this.currentStep = 100;
        // ставим фокус с сет таймаутом, чтобы ангуляр успел отрендерить страничку(отобразить инпут блок имейл)
        setTimeout(() => {
            if (this.InputBlockEmail) {
                this.InputBlockEmail.nativeElement.focus();
            }
        }, 0);
    }
    // подтверждение после ввода имейла или телефона
    public async onSubmitDeliveryChannel() {
        this.loading = true;
        const activeForm =
            this.recoveryMode === 'SMS' ? this.formPhone : this.formMail;
        const fieldName = this.recoveryMode === 'SMS' ? 'phone' : 'email';
        const oldField = this.recoveryMode === 'SMS' ? 'email' : 'phone';
        const captcha =
            this.recoveryMode === 'SMS'
                ? this.formPhone.controls['captcha'].value
                : this.formMail.controls['captcha'].value;
        this.patientData = {
            ...this.patientData,
            [fieldName]: activeForm.value[fieldName],
            [oldField]: undefined,
            client:
                this.recoveryMode === 'SMS'
                    ? {
                          platform: 'WEB',
                          otpDomain: this.document.location.hostname,
                      }
                    : undefined,
        };
        const captchaData: ICaptchaData = {
            id: this.captcha?.id,
            value: captcha,
        };
        try {
            const captchaVerifyResponse = await lastValueFrom(
                this.captchaService.verifyCaptcha(captchaData),
            );
            if (captchaVerifyResponse.captchaHash) {
                this.patientData = {
                    ...this.patientData,
                    captchaHash: captchaVerifyResponse.captchaHash,
                };
            }
        } catch (err: unknown) {
            this.errorMessage = Utils.getErrorMessage(
                err,
                'CAPTCHA устарела или код введён неверно',
            );
            this.refreshCaptcha();
            activeForm.get('captcha')?.reset();
            this.loading = false;
        }
        // сформировали данные для отправки, пробуем найти пациента и отправить код
        if (this.patientData.captchaHash) {
            try {
                const response: ISendAuthenticationCodeResponse =
                    await lastValueFrom(
                        this.auth.sendPasswordRecoveryCode(
                            this.patientData,
                            'RECOVERY',
                        ),
                    );
                if (response.messageUuid && response.patientId) {
                    const dataForcode: IDataForAuthCode = {
                        messageUuid: response.messageUuid,
                        delieveryChanel: this.recoveryMode,
                        phoneOrMail:
                            this.patientData.phone ||
                            this.patientData.email ||
                            '',
                    };
                    // после этого направляем на auth/code, в сервис отправляем messageUuid и delievery chanel
                    this.auth.startAuthProcess(dataForcode, 'RECOVERY');
                }
            } catch (err: unknown) {
                this.errorMessage = Utils.getErrorMessage(
                    err,
                    'Ошибка при отправке кода',
                );
                console.error('Ошибка на auth/recovery:', this.errorMessage);
                this.refreshCaptcha();
                this.formPhone.get('captcha')?.reset();
                this.formMail.get('captcha')?.reset();
                this.patientData.captchaHash = '';
                this.startTimer(this.timerDuration);
            } finally {
                this.loading = false;
            }
        }
    }
    public goToRegistration() {
        this.router.navigate(['auth/register']);
    }
    public backToLogin() {
        this.router.navigate(['/auth/login']);
    }
    public goBack() {
        switch (this.page) {
            case 'mailPhone':
                this.page = 'mainData';
                this.currentStep = 50;
                break;
            case 'mainData':
                this.backToLogin();
                break;
        }
    }
    public changeRecoveryMode(n: TDeliveryChannel) {
        this.recoveryMode = n;
    }
    public async getCaptcha() {
        this.captchaLoad = true;
        this.captcha = await this.captchaService.fetchCaptcha();
        this.captchaLoad = false;
    }
    public refreshCaptcha() {
        this.captcha = { id: '', svg: '' };
        this.formMail.controls['captcha']?.setValue('');
        this.formPhone.controls['captcha']?.setValue('');
        this.getCaptcha();
    }
    public removeSpaces(event: Event): void {
        const input = event.target as HTMLInputElement;
        input.value = input.value.replace(/\s/g, '');
    }

    public correctNameInput(event: Event, controlName: string): void {
        const input = event.target as HTMLInputElement;

        let value = input.value;

        value = value.replace(/[^a-zA-Zа-яА-ЯёЁ-]/g, '');

        value = value.replace(/^-+/, '');

        value = value.replace(/-{2,}/g, '-');

        if (input.value !== value) {
            input.value = value;
        }

        this.formRecoveryData.get(controlName)?.setValue(value, {
            emitEvent: false,
        });
    }
    public setFocus() {
        if (this.InputBlockLastName) {
            this.InputBlockLastName.nativeElement.focus();
        }
    }

    public onDateFocus(): void {
        this.dateInputType = 'date';
    }
    public onDateBlur(): void {
        if (!this.birthDateControl.value) {
            this.dateInputType = 'text';
        }
    }
    public get birthDateControl() {
        return this.formRecoveryData.controls['birthDate'];
    }
    public timerDisplay = computed(() => {
        const seconds = this.timerSeconds();
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    });
    private startTimer(seconds: number): void {
        this.stopTimer();

        this.timerSeconds.set(seconds);
        this.isRunning.set(true);

        this.subscription = interval(1000).subscribe(() => {
            const currentValue = this.timerSeconds();
            const newValue = currentValue - 1;

            if (newValue <= 0) {
                this.timerSeconds.set(0);
                this.isRunning.set(false);
                this.stopTimer();
            } else {
                this.timerSeconds.set(newValue);
            }
        });
    }

    private stopTimer(): void {
        this.isRunning.set(false);
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }

    public focusNextInput(event: Event): void {
        event.preventDefault();

        const target = event.target as HTMLElement;
        const form = target.closest('form');

        if (!form) {
            return;
        }

        const inputs = Array.from(
            form.querySelectorAll<HTMLInputElement>(
                'input:not([disabled]):not([readonly])',
            ),
        );

        const currentIndex = inputs.indexOf(target as HTMLInputElement);
        const nextInput = inputs[currentIndex + 1];

        if (nextInput) {
            nextInput.focus();
            return;
        }

        const button = form.querySelector<HTMLButtonElement>(
            'button[type="submit"]:not([disabled])',
        );

        if (button) {
            button.click();
        }

        target.blur();
    }
}
//TODO: Почистить код.
// import {
//     Component,
//     EventEmitter,
//     Input,
//     OnInit,
//     Output,
//     Inject,
// } from '@angular/core';
// import {
//     AbstractControl,
//     FormControl,
//     FormGroup,
//     ValidationErrors,
//     Validators,
// } from '@angular/forms';
// import { ConfigService } from '../../../services/application/config.service.';
// import { showOpacityAnimation } from '../../../animations/show-left-right.animation';
// import { AuthService } from '../../../services/auth.service';
// import { AlertService } from 'src/lib/ariadna/alert';
// import { LoadService } from '../../../services/application/load.service';
// import { Title } from '@angular/platform-browser';
// import { APP_BASE_HREF } from '@angular/common';
// import {
//     CaptchaService,
//     ICaptcha,
// } from 'src/app/services/captcha/captcha.service';
// import {
//     trigger,
//     state,
//     style,
//     transition,
//     animate,
// } from '@angular/animations';
// import { Router } from '@angular/router';

// @Component({
//     selector: 'app-recovery',
//     templateUrl: './recovery.component.html',
//     styleUrls: ['./recovery.component.scss'],
//     animations: [
//         trigger('showOpacityAnimation', [
//             state(
//                 'on',
//                 style({
//                     opacity: 1,
//                     visibility: 'visible',
//                 }),
//             ),
//             state(
//                 'off',
//                 style({
//                     opacity: 0,
//                     visibility: 'hidden',
//                 }),
//             ),
//             transition('void => on', [
//                 style({ opacity: 0, visibility: 'hidden' }),
//                 animate(
//                     '300ms ease-in',
//                     style({
//                         opacity: 1,
//                         visibility: 'visible',
//                     }),
//                 ),
//             ]),
//             transition('on => off', [
//                 animate(
//                     '300ms ease-out',
//                     style({
//                         opacity: 0,
//                         visibility: 'hidden',
//                     }),
//                 ),
//             ]),
//         ]),
//     ],
// })
// export class RecoveryComponent implements OnInit {
//     @Input() AccessReg: boolean = false;
//     animState = 'on';
//     loading = false;
//     recoveryForm!: FormGroup;
//     newPasswordForm!: FormGroup;
//     captchaImage = '';
//     maxDate!: string;
//     private recoveryToken: string | null = null;
//     isTokenRecovery: boolean = false;
//     private pageSetting: any;
//     captcha: ICaptcha | undefined = undefined;
//     newPassHidden: boolean = false;
//     newPassHiddenConfirm: boolean = false;

//     @Output() onChanged = new EventEmitter<number>();
//     @Output() onError = new EventEmitter<string>();

//     constructor(
//         private configService: ConfigService,
//         private router: Router,
//         private authService: AuthService,
//         private alertService: AlertService,
//         private load: LoadService,
//         private captchaService: CaptchaService,
//         @Inject(APP_BASE_HREF) private baseHref: string,
//         private titleService: Title,
//     ) {
//         const tmpTitle =
//             load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.RECOVERY.TITLE;
//         if (tmpTitle) this.titleService.setTitle(tmpTitle);

//         const recoveryPath = `${baseHref}login/recovery`;
//         this.recoveryToken = location.pathname.substring(recoveryPath.length);
//         this.recoveryToken = this.recoveryToken.substring(1);
//         if (!this.recoveryToken) {
//             this.isTokenRecovery = true;
//         }
//     }

//     ngOnInit(): void {
//         this.initializeForms();

//         this.getCaptcha();
//     }

//     private initializeForms(): void {
//         // Валидатор для сравнения паролей
//         const passwordMatchValidator = (
//             control: AbstractControl,
//         ): ValidationErrors | null => {
//             const newPassword = control.get('newPW')?.value;
//             const confirmPassword = control.get('newPW2')?.value;

//             // Проверяем, что оба поля заполнены
//             if (!newPassword || !confirmPassword) {
//                 return null; // Не показываем ошибку, если одно из полей пустое
//             }

//             return newPassword === confirmPassword
//                 ? null
//                 : { passwordMismatch: true };
//         };
//         this.recoveryForm = new FormGroup({
//             captcha: new FormControl('', [
//                 Validators.minLength(4),
//                 Validators.maxLength(10),
//             ]),
//             lastName: new FormControl('', [Validators.minLength(3)]),
//             firstName: new FormControl('', [Validators.minLength(3)]),
//             secondName: new FormControl('', [Validators.minLength(1)]),
//             birthDate: new FormControl('', [Validators.minLength(1)]),
//             email: new FormControl('', [Validators.email]),
//         });

//         this.newPasswordForm = new FormGroup(
//             {
//                 newPW: new FormControl('', [
//                     Validators.required,
//                     Validators.minLength(3),
//                 ]),
//                 newPW2: new FormControl('', [
//                     Validators.required,
//                     Validators.minLength(3),
//                     this.confirmPasswordValidator,
//                 ]),
//             },
//             { validators: passwordMatchValidator },
//         );
//     }

//     public confirmPasswordValidator(
//         control: AbstractControl,
//     ): ValidationErrors | null {
//         const newPassword = control.parent?.get('newPW')?.value;
//         const confirmPassword = control.value;

//         // Если одно из полей пустое — не показываем ошибку
//         if (!newPassword || !confirmPassword) {
//             return null;
//         }

//         return newPassword === confirmPassword
//             ? null
//             : { passwordMismatch: true };
//     }

//     whenAnimate(event: any) {
//         if (event.toState === 'off') {
//             this.onChanged.emit(0);
//         }
//     }

//     // Получение капчи
//     async getCaptcha() {
//         this.loading = true;
//         this.captcha = await this.captchaService.fetchCaptcha();
//         this.loading = false;
//     }

//     public refreshCaptcha() {
//         this.captcha = undefined;

//         this.recoveryForm.controls['captcha']?.setValue('');
//         this.getCaptcha();
//     }

//     goAuth(): void {
//         this.animState = 'off';
//     }

// goRecovery() {
//     this.loading = true;
//     const formControls = this.recoveryForm.controls;

//     this.authService
//         .sendPasswordRecoveryCode(
//             formControls['lastName'].value,
//             formControls['firstName'].value,
//             formControls['secondName'].value,
//             formControls['birthDate'].value,
//             formControls['email'].value,
//             formControls['captcha'].value,
//             this.captcha?.id,
//             // this.captcha.id ? this.captcha.id.toString() : null
//         )
//         .subscribe({
//             next: (res) => {
//                 this.loading = false;

//                 if (res.messageUuid) {
//                     this.handleSuccess();
//                 } else {
//                     this.handleError(
//                         'Что-то пошло не так, попробуйте позже.',
//                     );
//                 }
//             },
//             error: (error) => {
//                 this.loading = false;
//                 this.handleError(Utils.getErrorMessage(error));
//             },
//         });
// }

//     private handleSuccess() {
//         sessionStorage.setItem('recoveryMessage', 'recoveryMessage');
//         window.location.href = `${this.baseHref}login`;
//     }

//     private handleError(errorMessage: string) {
//         this.refreshCaptcha();
//         this.alertService.error('Ошибка: ' + errorMessage);
//     }

//     // Восстановление пароля - после поиска пациента, непосредственно отправка нового пароля и его повтора
//     goRecoveryNewPW() {
//         this.loading = true;
//         this.authService
//             .recoveryPassword(
//                 this.newPasswordForm.controls['newPW'].value,
//                 this.newPasswordForm.controls['newPW2'].value,
//             )
//             .subscribe({
//                 next: (res) => {
//                     this.alertService.info('Пароль успешно изменен.', 9000);
//                     setTimeout(() => {
//                         this.router.navigate(['/login']);
//                     }, 5000);
//                 },
//                 error: (err) => {
//                     this.loading = false;
//                     this.alertService.error(Utils.getErrorMessage(err));
//                 },
//             });
//     }

//     isCopyPassword(): boolean {
//         return (
//             this.newPasswordForm &&
//             this.newPasswordForm.controls['newPW'] &&
//             this.newPasswordForm.controls['newPW'].value &&
//             this.newPasswordForm.controls['newPW2'] &&
//             this.newPasswordForm.controls['newPW2'].value &&
//             this.newPasswordForm.controls['newPW'].value ===
//                 this.newPasswordForm.controls['newPW2'].value
//         );
//     }

//     public numberOnly(event: any): boolean {
//         // Проверяем длину значения в поле
//         if (
//             event.target.value.length >= 4 &&
//             event.keyCode !== 8 &&
//             event.keyCode !== 46
//         ) {
//             return false;
//         }

//         const charCode = event.which ? event.which : event.keyCode;

//         // Разрешаем клавиши удаления (backspace, delete)
//         if (charCode === 8 || charCode === 46) {
//             return true;
//         }

//         // Запрет ввода нуля в начале
//         if (charCode === 48 && event.target.value.length === 0) {
//             return false;
//         }

//         // Разрешаем только цифры (коды 48-57)
//         return !(charCode > 31 && (charCode < 48 || charCode > 57));
//     }

//     newPassHiddenHandler() {
//         this.newPassHidden = !this.newPassHidden;
//     }
//     newPassHiddenHandlerConfirm() {
//         this.newPassHiddenConfirm = !this.newPassHiddenConfirm;
//     }
// }
